import { render, staticRenderFns } from "./EmailCreate.vue?vue&type=template&id=77e33fae&scoped=true"
import script from "./EmailCreate.vue?vue&type=script&lang=js"
export * from "./EmailCreate.vue?vue&type=script&lang=js"
import style0 from "./EmailCreate.vue?vue&type=style&index=0&id=77e33fae&prod&lang=stylus&scoped=true"
import style1 from "./EmailCreate.vue?vue&type=style&index=1&id=77e33fae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e33fae",
  null
  
)

export default component.exports